import React from 'react';
import { createRoot } from 'react-dom/client';

import UserConfirmation from './UserConfirmation';

export const SILENT_BLOCK_MESSAGE = '__NEXLA_BLOCK_NAV__';

const getUserConfirmation = (message, callback) => {
  // Form handled navigation internally (e.g. went back a stage) — just block the browser nav
  if (message === SILENT_BLOCK_MESSAGE) {
    callback(false);
    return;
  }

  // Prevent stacking: if a dialog is already open, block new navigation attempts
  if (document.getElementById('modal')) {
    callback(false);
    return;
  }

  const modal = document.createElement('div');
  modal.id = 'modal';
  document.body.appendChild(modal);

  const root = createRoot(modal);

  const withCleanup = (answer) => {
    root.unmount(modal);
    document.body.removeChild(modal);
    callback(answer);
  };

  root.render(
    <UserConfirmation
      message={message}
      onCancel={() => withCleanup(false)}
      onConfirm={() => withCleanup(true)}
    />,
  );
};

export default getUserConfirmation;
